import { VersioningCardProps } from "./versioningCard.interface";
import { setResourceIcon } from "../../../../../../../scripts/resourceHelper";
import { allFormatRegex, getFileNameWithoutFormat } from "../../../../../../../scripts/helpers";
import dots from "../../../../../../../assets/images/svg/more.svg";
import clock from "../../../../../../../assets/images/svg/clock1.svg";
import trash from "../../../../../../../assets/images/icons/trash-red.svg";
import { ReactComponent as Download } from "../../../../../../../assets/images/fileManager/context/Download.svg";
import moment from "moment-jalaali";
import { Menu } from "@szhsin/react-menu";
import { useState } from "react";
import CheckBox from "../../../../../checkbox/checkbox.index";
import { advancedResponseValidator, del, put } from "../../../../../../../scripts/api";
import API from "../../../../../../../urls/api";
import ConfirmationModal from "../../../../../confirmationModal/confirmationModal.index";
import { useAppSelector } from "../../../../../../../redux/hooks";
import { shallowEqual } from "react-redux";

export default function VersioningCard(props: VersioningCardProps): JSX.Element {
    const format = props.resource.name ? props.resource.name.match(allFormatRegex) : "";
    const { versionResources } = useAppSelector(({ fileManager: { versionResources } }) => ({ versionResources }), shallowEqual);
    const [keepForEver, setKeepForEver] = useState(props.resource.keep_forever as boolean);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);

    const handleKeepForEver = () => {
        setKeepForEver(true);
        put(
            (data, status) => {
                if (advancedResponseValidator(data, status)) {
                }
            },
            API.fileManager.keep(props.resource.id),
            {}
        );
    };

    const handleUnKeepForEver = () => {
        setKeepForEver(false);
        put(
            (data, status) => {
                if (advancedResponseValidator(data, status)) {
                }
            },
            API.fileManager.unKeep(props.resource.id),
            {}
        );
    };

    const handleDeleteResource = () => {
        return new Promise((resolve) => {
            del(
                (data, status) => {
                    if (advancedResponseValidator(data, status)) {
                        setDeleteConfirmationModal(false);
                        props.onDelete();
                    }
                    resolve(true);
                },
                API.fileManager.deleteSingleVersion(props.resource.id),
                {}
            );
        });
    };

    function downloadResource() {
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = props.resource;
        a.href = file.download_url;
        a.click();
    }

    return (
        <div className="p-4 bg-[#F6F8FF] rounded-[8px] mb-4 flex gap-4">
            <div className="flex-1 overflow-auto">
                <div className="flex gap-4">
                    <div className="relative shrink-0">
                        <>
                            <div
                                className={`text-white text-[9px] ${format && (format[0].slice(1).length === 6 || format[0].slice(1).length === 5) && "text-[4px]"} ${format && format[0].slice(1).length === 4 && "text-[7px]"} absolute top-[1px] right-[1px] rounded-sm w-full tracking-widest uppercase z-[100]`}
                            >
                                {format ? format[0].slice(1) : null}
                            </div>
                            <img
                                className="w-[30px] drop-shadow-lg"
                                src={setResourceIcon(getFileNameWithoutFormat(props.resource).format)}
                                alt={props.resource.name}
                                loading="lazy"
                            />
                        </>
                    </div>
                    <div className="overflow-auto">
                        <div className="flex items-center gap-2 mb-1">
                            <h3 className="font-bold text-[14px] text-secondary-600 shrink-0">
                                نسخه {props.resource.is_current_version ? "فعلی" : props.resource.version}
                            </h3>
                            <span className="text-[14px] text-secondary-600 truncate">{props.resource.name}</span>
                        </div>
                        <div className="flex items-center flex-wrap gap-1">
                            <div className="flex items-center gap-1">
                                <img src={clock} alt="clock" />
                                <span className="text-[12px] text-secondary-600">
                                    {moment.unix(props.resource.created_at).format("jD jMMMM jYYYY ، HH:mm")}
                                </span>
                            </div>
                            <p className="text-[12px] text-secondary-600">{props.resource.user.name}</p>
                        </div>
                    </div>
                </div>
            </div>
            <Menu
                portal={true}
                id="versioning-card"
                menuClassName={`!w-[220px] absolute bg-white !p-0 overflow-hidden !rounded-[5px] !drop-shadow-xl !shadow-none !select-none !z-[1000]`}
                menuButton={
                    <div
                        className="flex items-center justify-center rotate-90 cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                    >
                        <img src={dots} alt="" />
                    </div>
                }
            >
                <div>
                    <div className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group" onClick={downloadResource}>
                        <Download className="fill-secondary-500" width="20px" height="20px" />
                        <span className={`text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all`}>دانلود</span>
                    </div>
                    {!props.resource.is_current_version && (
                        <div className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group">
                            <CheckBox
                                className="text-secondary-800 text-[14px] !font-bold group-hover:text-primary-600"
                                label="نگه‌داری برای همیشه"
                                onChange={(value) => {
                                    if (value) {
                                        handleKeepForEver();
                                    } else {
                                        handleUnKeepForEver();
                                    }
                                }}
                                defaultValue={keepForEver}
                            />
                        </div>
                    )}
                    {versionResources && versionResources.length > 1 && (
                        <div
                            className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group"
                            onClick={() => setDeleteConfirmationModal(true)}
                        >
                            <img src={trash} alt="" />
                            <span className={`text-red-500 text-[14px] font-bold transition-all`}>حذف</span>
                        </div>
                    )}
                </div>
            </Menu>
            <ConfirmationModal
                status={deleteConfirmationModal}
                onClose={() => setDeleteConfirmationModal(false)}
                onSubmit={handleDeleteResource}
                modalType="DELETE"
                text={`${props.resource.is_current_version ? "نسخه فعلی" : `نسخه ${props.resource.version}`}در حال حذف دائمی است. این عملیات قابل‌بازگشت نیست. آیا مطمئن هستید؟`}
                cancelButtonText="انصراف"
                submitButtonText="بله، حذف برای همیشه"
                closeOnBlur={false}
            />
        </div>
    );
}
